module.exports = __webpack_public_path__ + "static/media/example01-02.b59a9e0b.svg";